/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {isOnPremisesInstallation} from '../../../../app/modules/auth/core/onPremisesAccess'
import {UserAvatar} from '../../../../app/modules/profile/components/UserAvatar'
import {isRunningInstalled, nativeApp, openInstallGuide} from '../../../../app/modules/install-app'
import {SelectCompany} from './SelectCompany'
import {isStaff, staffExpiresAt} from '../../../../app/modules/auth/core/staffAccess'

// The staff session's end, as an hour of Tehran time (iran-time-everywhere).
const formatStaffEnd = (at?: Date): string => {
  if (!at) return ''
  try {
    return at.toLocaleTimeString('fa-IR', {hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Tehran'})
  } catch {
    return ''
  }
}

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  // Inside «معتمد آسا» for Android: the app's own settings (lock, notifications, updates).
  const app = nativeApp()
  const staffEnd = formatStaffEnd(staffExpiresAt(currentUser))
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      {currentUser && (
        <>
          <div className='menu-item px-3'>
            {isStaff(currentUser) ? (
              <div className='menu-content d-flex align-items-center px-3'>
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-light-primary text-primary fs-2 fw-bolder'>
                    <i className='las la-user-tie fs-2 text-primary' aria-hidden='true'></i>
                  </span>
                </div>
                <div className='d-flex flex-column min-w-0'>
                  <div className='fw-bolder fs-6'>{`کارمند · ${currentUser.staff?.name || 'بدون نام'}`}</div>
                  <span className='fw-bold text-muted fs-7'>از CRM</span>
                  {staffEnd && (
                    <span className='fw-bold text-muted fs-8'>{`پایان نشست: ${staffEnd}`}</span>
                  )}
                </div>
              </div>
            ) : currentUser.support ? (
              <div className='menu-content d-flex align-items-center px-3'>
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label bg-light-warning text-warning fs-2 fw-bolder'>
                    <i className='bi bi-shield-lock fs-2 text-warning'></i>
                  </span>
                </div>
                <div className='d-flex flex-column'>
                  <div className='fw-bolder fs-6'>حالت پشتیبانی</div>
                  <span className='fw-bold text-muted fs-7'>
                    {currentUser.support.operator_name || currentUser.support.crm_user_id}
                  </span>
                  <span className='fw-bold text-muted fs-8'>{currentUser.support.company_name}</span>
                </div>
              </div>
            ) : (
              <Link to='/profile/account'>
                <div className='menu-content d-flex align-items-center px-3'>
                  <div className='me-4'>
                    <UserAvatar user={currentUser} size={50} />
                  </div>

                  <div className='d-flex flex-column min-w-0'>
                    <div className='fw-bolder d-flex align-items-center flex-wrap fs-5 text-gray-900'>
                      {`${currentUser?.fn || ''} ${currentUser?.ln || ''}`.trim() || 'کاربر بدون نام'}
                    </div>
                    {currentUser?.un && (
                      <span className='fw-bold text-muted text-hover-primary fs-7 englishText' dir='ltr'>
                        {currentUser.un}
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            )}
          </div>

          <div className='separator my-2'></div>

          {/* A staff session has no account in the panel: its name and sections come from the CRM. */}
          {!currentUser.support && !isStaff(currentUser) && (
            <>
              <div className='menu-item px-5'>
                <Link to='/profile/account' className='menu-link px-5'>
                  <i className='las la-id-card fs-3 me-2' aria-hidden='true' />
                  حساب کاربری
                </Link>
              </div>
              <div className='menu-item px-5'>
                <Link to='/profile/security' className='menu-link px-5'>
                  <i className='las la-shield-alt fs-3 me-2' aria-hidden='true' />
                  امنیت و ورود
                </Link>
              </div>
              {/* An on-premises install has no notification centre. */}
              {!isOnPremisesInstallation(currentUser) && (
                <div className='menu-item px-5'>
                  <Link to='/profile/notifications/settings' className='menu-link px-5'>
                    <i className='las la-bell fs-3 me-2' aria-hidden='true' />
                    تنظیمات اعلان
                  </Link>
                </div>
              )}
              {app && (
                <div className='menu-item px-5'>
                  <a
                    href='#'
                    onClick={(event) => {
                      event.preventDefault()
                      app.openSettings()
                    }}
                    className='menu-link px-5'
                  >
                    <i className='las la-mobile-alt fs-3 me-2' aria-hidden='true' />
                    تنظیمات برنامه
                  </a>
                </div>
              )}
              {/* Inside the installed app there is nothing to install. */}
              {!isRunningInstalled() && (
                <div className='menu-item px-5'>
                  <a
                    href='#'
                    onClick={(event) => {
                      event.preventDefault()
                      openInstallGuide()
                    }}
                    className='menu-link px-5'
                  >
                    <i className='las la-download fs-3 me-2' aria-hidden='true' />
                    نصب برنامه
                  </a>
                </div>
              )}
            </>
          )}
          {/*
      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>

      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div>

      <div className='separator my-2'></div> */}

          {/* <Languages /> */}
          {/* «کسب‌وکار»: a submenu for switching the selected business, an administrator's too (with search). */}
          {!currentUser.support && <SelectCompany />}

          {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

          <div className='separator my-2'></div>

          <div className='menu-item px-5'>
            <a
              href='#'
              onClick={(event) => {
                event.preventDefault()
                logout()
              }}
              className='menu-link px-5 text-danger'
            >
              <i className='las la-sign-out-alt fs-3 me-2' aria-hidden='true' />
              {isStaff(currentUser) ? 'خروج' : 'خروج از حساب'}
            </a>
          </div>
        </>
      )}
      {!currentUser && (
        <>
          <div className='menu-item px-5'>
            <a href={'/auth'} className='menu-link px-5'>
              ورود
            </a>
          </div>
          <div className='menu-item px-5'>
            <a href={'/register/loginmenu'} className='menu-link px-5'>
              ثبت نام
            </a>
          </div>
        </>
      )}
    </div>
  )
}

export {HeaderUserMenu}
